module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/img_mob-10c465ee7a4a642bab62aced4cc2118e.png";